import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

/** The public "Register now" link — /r/:key (a class slug, a room name, or the
 *  evergreen `live`). No form, no interstitial: it mints the seat and drops
 *  them straight into the fees checkout. */
export default function RegisterPay() {
  const { roomName: key } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    document.title = "Pay your fees · Udyog Classes";
    let dead = false;
    (async () => {
      try {
        const { data: target } = await api.get(`/public/register/${key}`);
        const room = target.room_name;
        // One payment per device per class, so re-opening the link resumes the
        // same seat instead of piling up records.
        const cached = localStorage.getItem(`udyog_pay_id_${room}`);
        if (cached) {
          if (!dead) navigate(`/pay/${cached}`, { replace: true });
          return;
        }
        const { data } = await api.post(`/meetings/${room}/pay/intent`, {
          user_name: `Guest ${Math.random().toString(36).slice(2, 6).toUpperCase()}`,
          kind: "full",
        });
        localStorage.setItem(`udyog_pay_id_${room}`, data.id);
        if (!dead) navigate(`/pay/${data.id}`, { replace: true });
      } catch (e) {
        if (!dead)
          setErr(
            e?.response?.data?.detail || "This registration link is not active any more."
          );
      }
    })();
    return () => {
      dead = true;
    };
  }, [key, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#050505] px-6" data-testid="register-page">
      {err ? (
        <span className="text-center text-[13px] text-white/60" data-testid="register-error">
          {err}
        </span>
      ) : (
        <span className="flex items-center gap-3 text-white/40 text-[13px]">
          <Loader2 className="w-4 h-4 animate-spin" /> Opening your fees page…
        </span>
      )}
    </div>
  );
}
